import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { MutationConfig } from 'src/lib/react-query';

const RESOURCE = '/payments/:parkingId/payment-orders/nra-export/';

interface DTO {
    parkingId: string;
    date_after: string;
    date_before: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, ...data }: DTO): Promise<Blob> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data, { responseType: 'blob' });
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export {
    RESOURCE as EXPORT_PAYMENTS_NRA_RESOURCE,
    mutationFn as exportPaymentsNRA,
    useMutationHook as useExportPaymentsNRA,
};
